import { ReactNode, forwardRef } from "react";

interface iWrapperRight {
	className?: string;
	children: ReactNode;
}
export const WrapperRight = forwardRef<HTMLElement, iWrapperRight>(
	(props, ref) => {
		const className = `wrapper-right ${props.className ? props.className : ""}`;
		return (
			<section ref={ref} className={className}>
				{props.children}
			</section>
		);
	},
);

WrapperRight.displayName = "WrapperRight";
